import { Calendar } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../../i18n/config';
import { Button } from '../../ui/button';

interface CasesEmptyStateProps {
  searchTerm: string;
  onClearSearch: () => void;
}

/**
 * Component for displaying the empty state when no cases are found
 */
const CasesEmptyState: React.FC<CasesEmptyStateProps> = ({ searchTerm, onClearSearch }) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      dir={getLanguageDirection(i18n.language)}
      className="p-6 text-center rounded-xl border-2 border-dashed border-gold/20 bg-background/50"
    >
      <Calendar className="w-9 h-9 mx-auto mb-3 text-muted-foreground/50" />
      <p className="text-sm text-muted-foreground mb-2">
        {searchTerm ? t('components.cases.noMatchingCases') : t('components.cases.noCases')}
      </p>

      {searchTerm && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClearSearch}
          className="mt-2"
        >
          {t('components.cases.clearSearch')}
        </Button>
      )}
    </div>
  );
};

export default CasesEmptyState;
